/**
 * App Theme Configuration
 *
 * Edit this file to change colors, font, and border radius.
 * The ThemeProvider applies these values as CSS variables on startup.
 *
 * Colors use HSL format: "hue saturation% lightness%"
 *
 * For preset inspiration, see src/lib/themes.ts — copy any preset's
 * values here and customize as needed.
 */

// ── Font presets (uncomment one, or add your own Google Fonts URL) ──
// Geometric sans — tech, clean, modern
// const font = { url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400..700&display=swap', family: "'Inter', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400..700&display=swap', family: "'Space Grotesk', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Sora:wght@400..700&display=swap', family: "'Sora', sans-serif" };
// Humanist sans — friendly, approachable
// const font = { url: 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400..700&display=swap', family: "'DM Sans', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400..700&display=swap', family: "'Plus Jakarta Sans', sans-serif" };
// Serif — luxury, editorial, premium
// const font = { url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400..900&display=swap', family: "'Playfair Display', serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400..700&display=swap', family: "'Cormorant Garamond', serif" };
// Mono — developer, hacker, terminal
// const font = { url: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400..700&display=swap', family: "'JetBrains Mono', monospace" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap', family: "'Space Mono', monospace" };
// Display — bold, creative, expressive
// const font = { url: 'https://fonts.googleapis.com/css2?family=Unbounded:wght@400..700&display=swap', family: "'Unbounded', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Syne:wght@400..700&display=swap', family: "'Syne', sans-serif" };

// Active font — Hanken Grotesk: a technical, geometric grotesque with tight
// bold weights, well suited to an institutional crypto intelligence dashboard.
const font = { url: 'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400..800&display=swap', family: "'Hanken Grotesk', sans-serif" };

// ClusterScope — dark institutional intelligence dashboard theme.
// Near-black base, teal/emerald primary, violet secondary accent.
export const theme = {
  colors: {
    background: '228 24% 4%',
    foreground: '0 0% 96%',
    card: '228 20% 8%',
    'card-foreground': '0 0% 96%',
    popover: '228 22% 7%',
    'popover-foreground': '0 0% 96%',
    primary: '166 70% 42%',
    'primary-foreground': '228 30% 6%',
    secondary: '228 18% 14%',
    'secondary-foreground': '0 0% 88%',
    muted: '228 16% 12%',
    'muted-foreground': '220 10% 60%',
    accent: '261 93% 73%',
    'accent-foreground': '228 30% 6%',
    destructive: '0 72% 51%',
    'destructive-foreground': '0 0% 100%',
    border: '228 15% 18%',
    input: '228 15% 18%',
    ring: '166 70% 42%',
    link: '166 60% 50%',
    'link-hover': '166 65% 58%',
    button: '228 18% 13%',
    'button-foreground': '0 0% 95%',
    'button-border': '228 15% 22%',
    'button-hover': '228 18% 18%',
    'button-hover-foreground': '0 0% 98%',
    'button-hover-border': '166 50% 35%',
    'button-ring': '166 70% 42%',
    'chart-1': '166 84% 48%',
    'chart-2': '261 93% 73%',
    'chart-3': '27 96% 61%',
    'chart-4': '330 85% 70%',
    'chart-5': '199 89% 60%',
    'sidebar-background': '228 24% 5%',
    'sidebar-foreground': '0 0% 82%',
    'sidebar-primary': '166 84% 48%',
    'sidebar-primary-foreground': '228 30% 6%',
    'sidebar-accent': '228 18% 12%',
    'sidebar-accent-foreground': '0 0% 85%',
    'sidebar-border': '228 15% 15%',
    'sidebar-ring': '166 84% 48%',
  },
  font,
  radius: '0.875rem',
};
